import React from 'react';
import Swal from 'sweetalert2';
import ReactSelect from 'react-select';
import withReactContent from 'sweetalert2-react-content';
import styled, { css } from 'styled-components';
import scrollBar from '../../UI/Editor/shared/scrollBar';
import { white, dimGray, grayShade1 } from '../../../../../styling/theme';

const ReactSelectElement = styled(ReactSelect)`
  width: ${(props) => props.fullWidth || '220px'};
  height: 48px;

  background: ${white};
  border-radius: 4px;
  border-color: ${white};

  .react-select__menu {
    .react-select__menu-list {
      overflow: overlay;
      ${() => {
        const scrollBarStyles = () =>
          scrollBar({ width: '6px', height: '6px' });
        return css`
          ${scrollBarStyles}
        `;
      }};

      .react-select__option {
        font-family: Arial;
        font-style: italic;
        font-weight: normal;
        font-size: 12px;
        line-height: 14px;
        color: rgba(0, 0, 0, 0.8);

        &:hover {
          background-color: ${grayShade1};
        }
      }
    }
  }

  .react-select__control {
    background: ${white};
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
    border-radius: 4px;
    border: ${dimGray};
    width: 100%;
    height: 100%;
    outline: none;
    grid-row: 1 / span 1;
    font-family: Arial;
    font-style: italic;
    font-weight: normal;
    font-size: 12px;

    border-color: ${white};

    &:hover {
      border-color: ${white};
    }
  }
`;

export const SomethingWentWrong = () => {
  withReactContent(Swal).fire({
    type: 'error',
    title: 'Oops...',
    text: `Something went wrong! Please try again`,
    footer: <a href="/help">Contact Support</a>,
  });
};

export const crossrefAPI = (query) => {
  try {
    const URL =
      'https://d55w38c9wf.execute-api.us-west-2.amazonaws.com/dev/works?';

    if (typeof query !== 'string') {
      return 'Invalid Search keywords!';
    }
    if (query === '') {
      return 'Empty query is not allowed!';
    }
    return fetch(`${URL}${query}&mailto=admin@wisedoc.net`);
  } catch (err) {
    SomethingWentWrong();
    return null;
  }
};

export const AllContributorTitle = [
  { id: 'author', label: 'Author' },
  { id: 'editor', label: 'Editor' },
  { id: 'translator', label: 'Translator' },
  { id: 'chair', label: 'Chair' },
];
export const AllWorkTypes = [
  { id: 'journal-article', label: 'Journal Article' },
  { id: 'monograph', label: 'Monograph' },
  { id: 'report', label: 'Report' },
  { id: 'peer-review', label: 'Peer Review' },
  { id: 'book-track', label: 'Book Track' },
  { id: 'book-part', label: 'Part' },
  { id: 'book-section', label: 'Book Section' },
  { id: 'other', label: 'Other' },
  { id: 'book', label: 'Book' },
  { id: 'journal-volume', label: 'Journal Volume' },
  { id: 'book-set', label: 'Book Set' },
  { id: 'reference-entry', label: 'Reference Entry' },
  { id: 'proceedings-article', label: 'Proceedings Article' },
  { id: 'journal', label: 'Journal' },
  { id: 'component', label: 'Component' },
  { id: 'book-chapter', label: 'Book Chapter' },
  { id: 'proceedings-series', label: 'Proceedings Series' },
  { id: 'report-series', label: 'Report Series' },
  { id: 'proceedings', label: 'Proceedings' },
  { id: 'standard', label: 'Standard' },
  { id: 'reference-book', label: 'Reference Book' },
  { id: 'posted-content', label: 'Posted Content' },
  { id: 'journal-issue', label: 'Journal Issue' },
  { id: 'dissertation', label: 'Dissertation' },
  { id: 'dataset', label: 'Dataset' },
  { id: 'book-series', label: 'Book Series' },
  { id: 'edited-book', label: 'Edited Book' },
  { id: 'standard-series', label: 'Standard Series' },
];

export const AllSortKeys = [
  { id: 'score', label: 'Relevance score (default)' },
  { id: 'deposited', label: 'Time of deposit' },
  { id: 'indexed', label: 'Time of index' },
  { id: 'published', label: 'Publication date' },
  { id: 'published-print', label: 'Print date' },
  { id: 'published-online', label: 'Online print date' },
  { id: 'issued', label: 'Issue date' },
  { id: 'is-referenced-by-count', label: 'Citation Count' },
  { id: 'references-count', label: 'Number of reference in work' },
];

export const SortingOrder = [
  { id: 'asc', label: 'Ascending (default)' },
  { id: 'desc', label: 'Descending' },
];

export const SelectComponent = (keyValue, keyName, handleChange, fullWidth) => {
  let keys = null;
  switch (keyName) {
    case 'title':
      keys = AllContributorTitle;
      break;
    case 'type':
      keys = AllWorkTypes;
      break;
    case 'sort':
      keys = AllSortKeys;
      break;
    case 'order':
      keys = SortingOrder;
      break;
    default:
      keys = []; // empty
  }

  return (
    <ReactSelectElement
      classNamePrefix="react-select"
      value={keyValue}
      onChange={(selectedOption) => handleChange(keyName, selectedOption)}
      options={keys.map((item) => ({ label: item.label, value: item.id }))}
      placeholder="Article Type"
      fullWidth={fullWidth}
    />
  );
};
